<template>
  <div class="ma-3">
    <div class="title mb-3">
      Address book <v-icon>mdi-chevron-right</v-icon> Functions management <v-icon>mdi-chevron-right</v-icon> {{ isNew ? 'New' : func.name }}
    </div>

    <v-form
      ref="form"
      v-model="formValid"
      layout="column"
      layout-align="center center"
      @submit.prevent="save"
    >
      <div>
        <div class="title font-weight-light mb-3">
          Function information
        </div>
        <v-text-field
          v-model="func.name"
          outline
          label="Name"
          class="field-width"
          :rules="[ v => !!v || 'This field is required' ]"
        />
      </div>

      <v-btn
        depressed
        color="primary"
        @click="save"
      >
        Save
      </v-btn>
      <router-link
        :to="{name: 'admin-addressbook-functions-index'}"
        class="grey--text"
      >
        Cancel
      </router-link>
    </v-form>
  </div>
</template>

<script>
    import Params from '@/api/params'

    export default {
        data () {
            return {
                func: {
                    name: null
                },
                formValid: false
            }
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }
        },
        methods: {
            fetch () {
                Params.get('functions', this.$route.params.id).then(res => {
                    this.func = res.data;
                })
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                if (this.isNew) {
                    Params.create('functions', this.func).then(() => {
                        this.$router.push({name: 'admin-addressbook-functions-index'});
                        this.$snotify.success(`The function "${this.function.name}" has been created`)
                    })
                } else {
                    Params.update('functions', this.func.id, this.func).then(() => {
                        this.$router.push({name: 'admin-addressbook-functions-index'});
                        this.$snotify.success(`The function "${this.func.name}" has been updated`)
                    })
                }
            }
        }
    }
</script>